import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { LedgerScreen } from "../screens/LedgerScreen";
import { ledgerSearch } from "../screens/reportSearch";

export const Route = createFileRoute("/prototype/c/$companyId/reports/ledger")({
  validateSearch: (search) => ledgerSearch.parse(search),
  component: Ledger,
});

function Ledger() {
  const { companyId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <LedgerScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      search={search}
    />
  );
}
